import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=505b210e&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"
import style0 from "./AppView.vue?vue&type=style&index=0&id=505b210e&prod&scoped=true&lang=scss"
import style1 from "./AppView.vue?vue&type=style&index=1&id=505b210e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b210e",
  null
  
)

export default component.exports